const adaptEpcOfferResponseData = data => ({
	...data,
});

export default adaptEpcOfferResponseData;
